"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPayloadData;
function getPayloadData(id, productCharacteristic, relatedParty) {
  var payload = {
    productOfferingQualification: {
      id: null
    },
    productOrder: {
      channel: [{
        id: '1',
        name: 'RETAIL10'
      }],
      productOrderItem: [{
        id: id,
        action: 'delete',
        product: {
          id: id,
          productCharacteristic: productCharacteristic
        }
      }],
      relatedParty: [{
        role: relatedParty[0].role,
        id: relatedParty[0].id,
        '@referredType': relatedParty[0]['@referredType']
      }]
    }
  };
  return payload;
}